import React from 'react';

interface ActivityItem {
  farm_name: string;
  action: string;
  detail: string;
  timestamp: string;
}

interface Props {
  items: ActivityItem[];
}

const EggWatchActivityFeed: React.FC<Props> = ({ items }) => {
  const formatTime = (ts: string) => {
    const d = new Date(ts);
    const now = new Date();
    const diffMs = now.getTime() - d.getTime();
    const diffMin = Math.floor(diffMs / 60000);
    if (diffMin < 60) return `${diffMin}m ago`;
    const diffHrs = Math.floor(diffMin / 60);
    if (diffHrs < 24) return `${diffHrs}h ago`;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  if (items.length === 0) {
    return <div className="ewa-empty-state">No recent activity</div>;
  }

  return (
    <div className="ewa-activity-feed">
      {items.map((item, i) => (
        <div key={i} className="ewa-activity-item">
          <div className="ewa-activity-time">{formatTime(item.timestamp)}</div>
          <div>
            <div className="ewa-activity-farm">{item.farm_name}</div>
            <div className="ewa-activity-detail">{item.action} — {item.detail}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EggWatchActivityFeed;
